import styled from 'styled-components';
import { BasketMandatoryFeesStyled } from '../BasketMandatoryFeesStyled';
import { rem } from 'polished';

export const BasketMandatoryFeesDetailsDS = styled(BasketMandatoryFeesStyled)`
    border-color: ${({ theme }) => theme.colors.secondary};

    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h4};
        }
    }

    .fees {
        .item {
            border-color: ${({ theme }) => theme.colors.grey28};

            &:last-child {
                border-color: ${({ theme }) => theme.colors.grey28};
            }
        }
    }
`;